<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <slot name="header">
                            Přejete si uložit změny a odsouhlasit novou cenu pro další krmivo?
                        </slot>
                    </div>

                    <div class="modal-body">
                        <div class="old-price">
                            <span class="label">Původní cena:</span> <span class="value">{{ oldPrice }}</span> <span class="currency">Kč</span>
                        </div>
                        <div class="new-price">
                            <span class="label">Nová cena:</span> <span class="value">{{ newPrice }}</span> <span class="currency">Kč</span>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                            <button class="modal-default-button" @click="$emit('close')">
                                Ne
                            </button>
                            <button class="modal-default-button" @click="confirmCallback">
                                Ano
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "ConfirmationModal",
    props: {
        oldPrice: Number,
        newPrice: Number,
        confirmCallback: Function,
    }
}
</script>



// WEBPACK FOOTER //
// ConfirmationModal.vue?23fe5b08